import { makeAutoObservable, extendObservable, observable, action, computed } from "mobx";
import TbSysUser from "domain/main/sys/user/TbSysUser";
import TbComPerson from "domain/main/com/person/TbComPerson";
import TbCommCorp from "domain/main/comm/corp/TbCommCorp";

export default class UserModel {
  @observable userLocale?: string;

  @observable tbSysUser: TbSysUser = new TbSysUser({});
  @observable tbComPerson: TbComPerson = new TbComPerson({});
  @observable tbCommCorp: TbCommCorp = new TbCommCorp({});

  @observable loginTy?: string;
  @observable personId?: string;
  @observable personNm?: string;
  @observable authorities?: Array<{authority:string}>;
  @observable userId?: string;


  public constructor(data?: any) {
    // console.log("UserModel start ", this, "data", data);

    // this.tbSysUser = new TbSysUser(data?.tbSysUser || {});
    // this.tbComPerson = new TbComPerson(data?.tbComPerson || {});
    // this.tbCommCorp = new TbCommCorp(data?.tbCommCorp || {});

    if (data) {
      extendObservable(this, data);
    }
    else {
      makeAutoObservable(this);
    }
    // console.log("UserModel end ", this, "data", data);
  }

  @computed
  public getUserLocale() {
    return this.userLocale;
  }

  @action
  public setUserLocale(userLocale: string) {
    this.userLocale = userLocale;
  }

  @computed
  public getTbSysUser(): TbSysUser {
    return this.tbSysUser;
  }

  @action
  public setTbSysUser(tbSysUser: TbSysUser) {
    this.tbSysUser = tbSysUser;
  }

  @computed
  public getTbComPerson(): TbComPerson {
    return this.tbComPerson;
  }

  @action
  public setTbComPerson(tbComPerson: TbComPerson) {
    this.tbComPerson = tbComPerson;
  }

  @computed
  public getLoginTy() {
    return this.loginTy;
  }

  @action
  public setLoginTy(loginTy: string) {
    this.loginTy = loginTy;
  }

  @computed
  public getPersonId() {
    return this.personId;
  }

  @action
  public setPersonId(personId: string) {
    this.personId = personId;
  }

  @computed
  public getPersonNm() {
    return this.personNm;
  }

  @action
  public setPersonNm(personNm: string) {
    this.personNm = personNm;
  }

  @computed
  public get loginName() {
    return this.getPersonNm();
  }

  public getUserId() {
    return this.userId;
  }

  public setUserId(value: string) {
    this.userId = value;
  }
  public getAuthorities() {
    return this.authorities?.reduce((accumulator, currentValue) => {
      accumulator.push(currentValue.authority)
      return accumulator
    }, [] as string[]);
  }

  public setAuthorities(value: {authority:string}[]) {
    this.authorities = value;
  }

  @computed
  public getTbCommCorp(): TbCommCorp {
    return this.tbCommCorp;
  }

  @action
  public setTbCommCorp(tbCommCorp: TbCommCorp) {
    this.tbCommCorp = tbCommCorp;
  }
}
